import React from 'react';
import { BlogListItem } from './blog-listing-item';
import { IBlogItem } from '../interfaces/types';

interface IBlogListProps {
    articles: IBlogItem[];
    isLoading: boolean;
    hasError: boolean;
}

export const BlogList: React.FC<IBlogListProps> = ({ articles, isLoading, hasError }) => {
    return (
        <>
            {isLoading && <div className="blog-listing-loading" role="status">Loading articles…</div>}
            {hasError && <div>Error loading articles.</div>}
            <ul role="list" className="blog-listing-list">
                {articles.map((article) => (
                    <li className="blog-listing-item" key={article.url || String(article.id)}>
                        <BlogListItem article={article} />
                    </li>
                ))}
            </ul>
        </>
    )
}